import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import { tagsToString } from '@src/main/ui/components/common/Dashboard/common/fields/tags/tagsToString';
import { useSearchContext } from '@src/main/ui/providers/search/SearchContextProvider';
import { FC } from 'react';
import Highlighter from 'react-highlight-words';

interface Props {
  tags: string[];
  highlighFields?: HighlighFields[];
}

const defaultProps = {
  highlighFields: undefined,
};

const TagsCardText: FC<Props> = ({ tags, highlighFields }) => {
  const { searchInput } = useSearchContext();
  const fieldToHighligh: HighlighFields = 'tags';
  return (
    <>
      {highlighFields?.includes(fieldToHighligh) ? (
        <Highlighter searchWords={searchInput.split(' ')} textToHighlight={tagsToString(tags)} />
      ) : (
        tagsToString(tags)
      )}
    </>
  );
};

TagsCardText.defaultProps = defaultProps;

export default TagsCardText;
